var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 11 19" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M.4 2.1c.3-.3.6-.5 1-.7L2.6.8C3 .6 3.5.4 3.9.4c.5-.1 1-.1 1.6-.1.7 0 1.4.1 2.1.3.6.1 1.2.4 1.6.8.4.4.8.9 1 1.4.2.6.4 1.2.4 1.8 0 .6-.1 1.1-.3 1.6-.2.4-.4.8-.7 1.2-.2.4-.5.7-.8.9l-.9.7c-.3.2-.6.4-.8.7-.2.2-.3.4-.4.7l-.4 1.8H3.7l-.3-2v-.1-.1c0-.4.1-.7.3-1 .2-.3.4-.5.7-.8.3-.2.6-.5.9-.7.2-.3.5-.5.8-.8.3-.2.5-.5.7-.8.1-.3.2-.7.2-1.1 0-.4-.2-.8-.5-1.1-.4-.3-.9-.5-1.4-.5-.4 0-.7 0-1.1.1-.2.1-.5.2-.7.4l-.6.3c-.1.1-.3.1-.5.1-.3 0-.6-.1-.8-.4l-1-1.6zm2.3 14.6c0-.3.1-.6.2-.8.1-.3.3-.5.5-.7.1-.2.4-.4.6-.5.3-.1.6-.2.9-.2.3 0 .6.1.9.2.2.1.5.3.7.5.4.4.6.9.6 1.5 0 .3-.1.6-.2.8-.1.3-.3.5-.5.7-.2.2-.4.3-.7.5-.3.1-.6.2-.9.2-.3 0-.6-.1-.9-.2-.7-.4-1.2-1.2-1.2-2z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/StatusInclarification.svg